import React from 'react'
import { Tooltip } from '@mui/material'
import { ILoanerRecord } from '../../LoanerVehicles'
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/delete.svg'
import { ReactComponent as ReopenIcon } from '../../../../assets/svg/restart_alt_12w.svg'
import styles from '../../LoanerVehicles.module.scss'

interface IClosedLoanerRowProps {
  loaner: ILoanerRecord
  onReopen: (loanerId: string) => void
  onDelete: (loanerId: string) => void
}

const ClosedLoanerRow = ({
  loaner,
  onReopen,
  onDelete,
}: IClosedLoanerRowProps) => {
  return (
    <tr key={loaner.id} className={styles.closedRow}>
      {/* Assigned Vehicle */}
      <td className={styles.readonlyField}>
        {loaner.assignedVehicle.name}
      </td>

      {/* Loaner vehicle */}
      <td>
        <span className={styles.readonlyText}>
          {loaner.loanerVehicle ? loaner.loanerVehicle.name : ' '}
        </span>
      </td>

      {/* Dates */}
      <td>
        <span className={styles.readonlyText}>
          {loaner.issuedDate}
        </span>
      </td>

      <td>
        <span className={styles.readonlyText}>
          {loaner.estimatedReturnDate || ' '}
        </span>
      </td>

      {/* Staff */}
      <td>
        <Tooltip title={loaner.assignedStaff} placement="top">
          <span className={styles.readonlyText}>
            {loaner.assignedStaff || ' '}
          </span>
        </Tooltip>
      </td>

      {/* Note */}
      <td>
        <Tooltip
          title={
            <div style={{ maxWidth: 100, whiteSpace: 'normal' }}>
              {loaner.note}
            </div>
          }
          placement="top-start"
        >
          <span className={styles.readonlyText}>
            {loaner.note || ' '}
          </span>
        </Tooltip>
      </td>

      {/* Closed date */}
      <td>
        <span className={styles.readonlyText}>
          {loaner.closedDate || ' '}
        </span>
      </td>

      {/* Action */}
      <td>
        <div className={styles.actionButtons}>
          <Tooltip title="Reopen" placement="top">
            <button
              className={styles.reopenButton}
              onClick={() => onReopen(loaner.id)}
            >
              <ReopenIcon />
            </button>
          </Tooltip>

          <Tooltip title="Delete" placement="top">
            <button
              className={styles.deleteButton}
              onClick={() => onDelete(loaner.id)}
            >
              <DeleteIcon />
            </button>
          </Tooltip>
        </div>
      </td>
    </tr>
  )
}

export default ClosedLoanerRow